import { ProductGetDTO, PackagedProductGetDTO } from 'svila-common';
import _ from 'lodash';
import { toRoman } from 'roman-numerals';
import { PACKAGE_TYPES } from './constants';

export const getFormDataFromValues = (values, skipIdConversion) => {
  const body = new FormData();
  for (let i = 0; i < Object.keys(values).length; i + 1) {
    const key = Object.keys(values)[i];
    if (!skipIdConversion) {
      if (key.endsWith('Id')) {
        body.append(key, values[key].value);
      } else {
        body.append(key, values[key]);
      }
    } else {
      body.append(key, values[key]);
    }
  }

  return body;
};

export const something = () => {
  return 2;
};

export const constantsToAutocomplete = (constant) => {
  const listOfOptions = [];
  Object.keys(constant).forEach((key) => {
    if (typeof constant[key] === 'string') {
      listOfOptions.push({ label: constant[key], value: constant[key] });
    } else {
      listOfOptions.push({ label: constant[key].label, value: constant[key].value });
    }
  });

  return listOfOptions;
};

export const constantsToAutocompleteStatusTypes = (constant) => {
  const listOfOptions = [];
  Object.keys(constant).forEach((key) => {
    listOfOptions.push(constant[key]);
  });

  return listOfOptions;
};

export const dataToAutocomplete = (data) => {
  const listOfOptions = [];
  data.forEach((item) => {
    listOfOptions.push({ label: item, value: item });
  });

  return listOfOptions;
};

export const autocompleteToList = (data: Autcomplete[]): string[] => {
  const listOfValues: string[] = [];
  data.forEach((item) => {
    listOfValues.push(item.value);
  });

  return listOfValues;
};

export const transformLabels = (value) => {
  const splitWord = _.startCase(value);
  const finalLabel = splitWord.replace('Id', '');

  return finalLabel;
};

export const getLocationFromFormik = (values) => {
  if (values.chamberNumber) {
    let tempString = `${toRoman(values.chamberNumber)} - ${values.column ? values.column : ''} - ${
      values.letter ? values.letter : ''
    } - ${values.level ? values.level : ''}`;

    return tempString;
  } else {
    return 'No Location';
  }
};

export const getLocationFromObject = (item) => {
  if (item.warehouseChamber) {
    let tempString = `${toRoman(item.warehouseChamber.number)} - ${item.column ? item.column : ''} - ${
      item.letter ? item.letter : ''
    } - ${item.level ? item.level : ''}`;

    return tempString;
  } else {
    return 'No Location';
  }
};

export const nullableNumberToString = (nullableNumber: number | null): string => {
  if (nullableNumber) {
    return nullableNumber.toString();
  }

  return '';
};

export const constantsToList = (constant) => {
  const listOfOptions = [];
  Object.keys(constant).forEach((key) => {
    listOfOptions.push(constant[key]);
  });

  return listOfOptions;
};

export const stringsToNull = (obj: any) => {
  const newObj = {};
  Object.keys(obj).forEach((key) => {
    if (obj[key] === '') {
      newObj[key] = null;
    } else {
      newObj[key] = obj[key];
    }
  });

  return newObj;
};

export const stringsToNullForId = (obj) => {
  const newObj = {};
  Object.keys(obj).forEach((key) => {
    if (obj[key] === '' && key.endsWith('Id')) {
      newObj[key] = null;
    } else {
      newObj[key] = obj[key];
    }
  });

  return newObj;
};

export const nullToString = (obj) => {
  const newObj = {};
  Object.keys(obj).forEach((key) => {
    if (obj[key] === null) {
      newObj[key] = '';
    } else {
      newObj[key] = obj[key];
    }
  });

  return newObj;
};

export const buildMessage = (messages) => {
  let fullMessage = '';
  messages.forEach((message) => {
    if (message) {
      if (fullMessage !== '') {
        fullMessage += ' : ';
      }
      fullMessage += message;
    }
  });
  
  return fullMessage;
};

export const convertToDropdown = (products: ProductGetDTO[]) => {
  const listOfOptions: { label: string; value: string }[] = [];
  products.forEach((product) => {
    listOfOptions.push({ label: product.manufacturer.name, value: product.manufacturer.id });
  });

  return listOfOptions;
};

export const sortPackaging = (packageList: PackagedProductGetDTO[]): PackagedProductGetDTO[] => {
  const sortedPackageList = [];
  const cus = packageList.filter((x) => x.pack.type == PACKAGE_TYPES.CONSUMER_UNIT);

  if (cus.length > 0) {
    sortedPackageList.push(...cus);
  }

  const dps = packageList.filter((x) => x.pack.type == PACKAGE_TYPES.DISPLAY);

  if (dps.length > 0) {
    sortedPackageList.push(...dps);
  }

  const duOfDps = packageList.filter(
    (x) => x.pack.type == PACKAGE_TYPES.DISTRIBUTION_UNIT && x.smallerUnit?.pack?.type === PACKAGE_TYPES.DISPLAY,

  );
  if (duOfDps.length > 0) {
    sortedPackageList.push(...duOfDps);
  }

  const dus = packageList.filter(
    (x) => x.pack.type == PACKAGE_TYPES.DISTRIBUTION_UNIT && x.smallerUnit?.pack?.type !== PACKAGE_TYPES.DISPLAY,
  );
  
  if (dus.length > 0) {
    sortedPackageList.push(...dus);
  }

  const layerOfCu = packageList.filter(
    (x) => x.pack.type == PACKAGE_TYPES.LAYER && x.smallerUnit?.pack?.type === PACKAGE_TYPES.CONSUMER_UNIT,
  );

  if (layerOfCu.length > 0) {
    sortedPackageList.push(...layerOfCu);
  }

  const layerOfDp = packageList.filter(
    (x) => x.pack.type == PACKAGE_TYPES.LAYER && x.smallerUnit?.pack?.type === PACKAGE_TYPES.DISPLAY,

  );
  if (layerOfDp) {
    sortedPackageList.push(...layerOfDp);
  }

  const layers = packageList.filter(
    (x) => x.pack.type == PACKAGE_TYPES.LAYER && x.smallerUnit?.pack?.type === PACKAGE_TYPES.DISTRIBUTION_UNIT,

  );
  if (layers.length > 0) {
    sortedPackageList.push(...layers);
  }

  const layersNull = packageList.filter(
    (x) => x.pack.type == PACKAGE_TYPES.LAYER && x.smallerUnit?.pack?.type == null,
  );

  if (layersNull.length > 0) {
    sortedPackageList.push(...layersNull);
  }

  const palletOfCu = packageList.filter(
    (x) => x.pack.type == PACKAGE_TYPES.PALLET && x.smallerUnit?.pack?.type === PACKAGE_TYPES.CONSUMER_UNIT,
  );

  if (palletOfCu) {
    sortedPackageList.push(...palletOfCu);
  }

  const palletOfDp = packageList.filter(
    (x) => x.pack.type == PACKAGE_TYPES.PALLET && x.smallerUnit?.pack?.type === PACKAGE_TYPES.DISPLAY,
  );

  if (palletOfDp) {
    sortedPackageList.push(...palletOfDp);
  }

  const palletOfDu = packageList.filter(
    (x) => x.pack.type == PACKAGE_TYPES.PALLET && x.smallerUnit?.pack?.type === PACKAGE_TYPES.DISTRIBUTION_UNIT,
  );

  if (palletOfDu) {
    sortedPackageList.push(...palletOfDu);
  }

  const palletOfLayer = packageList.filter(
    (x) => x.pack.type == PACKAGE_TYPES.PALLET && x.smallerUnit?.pack?.type === PACKAGE_TYPES.LAYER,
  );

  if (palletOfLayer) {
    sortedPackageList.push(...palletOfLayer);
  }

  const palletOfNull = packageList.filter(
    (x) => x.pack.type == PACKAGE_TYPES.PALLET && x.smallerUnit?.pack?.type == null,
  );

  if (palletOfNull) {
    sortedPackageList.push(...palletOfNull);
  }

  return sortedPackageList;
};

export const splitNoParen = (s: string): string[] => {
  let left = 0,
    right = 0,
    A: string[] = [],
    M = s.match(/([^()]+)|([()])/g),
    L = M.length,
    next,
    str = '';
  for (let i = 0; i < L; i++) {
    next = M[i];
    if (next === '(') ++left;
    else if (next === ')') ++right;
    if (left !== 0) {
      str += next;
      if (left === right) {
        A[A.length - 1] += str;
        left = right = 0;
        str = '';
      }
    } else A = A.concat(next.match(/([^,]+)/g));
  }
  return A;
};

export const calcPercentage = (partialValue: number, totalValue: number): number => {
  return (100 * partialValue) / totalValue;
};

export const calcValueOfPercentage = (num: number, percentage: number): number => {
  return num * (percentage / 100);
};

export const grantedForRole = (accessRoles, userRole): boolean => {
  if (accessRoles) {
    if (userRole && Array.isArray(userRole)) {
      if (userRole.some((r: string) => accessRoles.includes(r)) === false) {
        return false;
      }
    } else if (userRole && typeof userRole === 'string') {
      if (accessRoles.indexOf(userRole) === -1) {
        return false;
      }
    } else {
      return false;
    }
  }

  return true;
};

export const roundTo2digits = (decimal) => {
  const rounded = Math.round(decimal * 100) / 100;
  
  return rounded;
};

export const getOrderCustomerName = (option) => {
  if (option.fnbOrder === null) {
    return option?.customer?.name;
  } else {
    return `Fnb: ${option?.fnbOrder?.name} ${option?.fnbOrder?.nameLast}`;
  }
};
